import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FormGroup = (props) => (_jsxs("div", { className: "form-group", children: [_jsx("label", { children: props.label }), props.children] }));
